module.exports = __webpack_public_path__ + "static/media/sad-face.8de9220c.svg";